import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  logistics: null,
  downloadInProgress: {},
};

const logisticListingSlice = createSlice({
  name: "logisticListing",
  initialState,
  reducers: {
    fetchLogistics(state, action) {
      state.loading = true;
    },
    fetchLogisticsSuccess(state, action) {
      state.logistics = action.payload.data.document;
      state.loading = false;
    },
    fetchLogisticsFailure(state, action) {
      state.loading = false;
    },
    downloadDocument(state, action) {
      state.downloadInProgress[action.payload.id] = true;
    },
    downloadDocumentSuccess(state, action) {
      state.downloadInProgress[action.payload.id] = false;
    },
    downloadDocumentFailure(state, action) {
      state.downloadInProgress[action.payload.id] = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = logisticListingSlice;
